
import fetch from '../axios/fetch'
const configs = {
  debug: false,
  appId: '', // 必填，公众号的唯一标识
  timestamp: '', // 必填，生成签名的时间戳
  nonceStr: '', // 必填，生成签名的随机串
  signature: '',
  jsApiList: ['scanQRCode', 'startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'uploadVoice', 'translateVoice', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'checkJsApi', 'hideMenuItems', 'hideOptionMenu'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
}
const urlList = ['https://wx.emspost.com.cn/weixin/n/mcp/share/wxConfig', 'https://wx.gdems.com/weixin/n/mcp/share/wxConfig']
const getThirdParameters = async () => {
  fetch.post(
    process.env.NODE_ENV === 'production' ? urlList[1] : urlList[0],
    {
      // url: encodeURIComponent(location.href.split('#')[0])
      url: location.href.split('#')[0]
    },
    'application/x-www-form-urlencoded'
  ).then(res => {
    if (res.data && res.data.success) {
      configs.appId = res.data.map.appId
      configs.timestamp = res.data.map.timestamp
      configs.nonceStr = res.data.map.nonceStr
      configs.signature = res.data.map.signature
    }
  })
  return configs
}

const doWxConfig = async () => {
  const configs = await getThirdParameters()
  wx.config(configs)
}

export default doWxConfig
